import { useProjectName } from './useProjectName';

export const useProjectLogo = () => {
  const project = useProjectName();

  const logo = `/projects/${project}/logo.svg`;
  
  return logo
}